import React from "react";
import { useTranslation } from "react-i18next";
import { ConstantInfo } from "../../../core/constantInfo";

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="max-w-screen-2xl w-full place-self-center py-10">
        <section className="mb-12">
          <h1 className="text-3xl font-bold mb-6 text-center">{t("title")}</h1>
          <p className="text-lg mb-4 leading-relaxed">{t("description1")}</p>
          <p className="text-lg mb-6 leading-relaxed">{t("description2")}</p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("whatWeDo.title")}</h2>
          <ul className="space-y-3">
            <li key="what-we-do-1" className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">{t("whatWeDo.item1")}</span>
            </li>
            <li key="what-we-do-2" className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">{t("whatWeDo.item2")}</span>
            </li>
            <li key="what-we-do-3" className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">{t("whatWeDo.item3")}</span>
            </li>
            <li key="what-we-do-4" className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">{t("whatWeDo.item4")}</span>
            </li>
          </ul>
        </section>

        <section className="mb-8 p-4 border-l-4 border-yellow-400 bg-content4 bg-opacity-30">
          <p className="italic">{t("disclaimer")}</p>
        </section>

        <div className="border-t border-textsecondary my-8"></div>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            {t("contentDisclaimer.title")}
          </h2>
          <p className="mb-4">{t("contentDisclaimer.text1")}</p>
          <p>{t("contentDisclaimer.text2")}</p>
        </section>

        <section className="mb-12 bg-content2 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("legalNotice.title")}
          </h2>
          <p className="mb-4">{t("legalNotice.text1")}</p>
          <p className="mb-4">{t("legalNotice.text2")}</p>
          <p>{t("legalNotice.text3")}</p>
        </section>

        <section className="text-center">
          <h2 className="text-2xl font-semibold mb-6">Contact</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-sm font-medium mb-2">WhatsApp:</h3>
              <a
                className="hover:text-primary text-white"
                href={ConstantInfo.phone}
              >
                {ConstantInfo.phoneView}
              </a>
            </div>
            <div>
              <h3 className="text-sm font-medium mb-2">Email:</h3>
              <a
                className="hover:text-primary text-white"
                href={ConstantInfo.email + "Another question"}
              >
                {ConstantInfo.emailView}
              </a>
            </div>
          </div>
          <div className="mt-6">
            <h3 className="text-sm font-medium mb-2">Address:</h3>
            <p className="text-xs">DME-Tech LLC</p>
            <p className="text-xs">1007 N Orange St, Wilmington, DE 19801, USA</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
